import { render, staticRenderFns } from "./BaseColorSwatches.vue?vue&type=template&id=598d81e2&"
import script from "./BaseColorSwatches.vue?vue&type=script&lang=js&"
export * from "./BaseColorSwatches.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../sfra-webpack-builder/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/lucia/proyectos/byl_salesforce/sfra-webpack-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('598d81e2')) {
      api.createRecord('598d81e2', component.options)
    } else {
      api.reload('598d81e2', component.options)
    }
    module.hot.accept("./BaseColorSwatches.vue?vue&type=template&id=598d81e2&", function () {
      api.rerender('598d81e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app_byl_core/cartridges/app_byl_core/cartridge/client/default/js/vue/components/BaseColorSwatches.vue"
export default component.exports